import { Component, OnInit } from '@angular/core';
import { Property } from '../_models/property';
import { faSearch, faArrowRight, faHouse, faBuilding } from '@fortawesome/free-solid-svg-icons';
import { PropertyService } from '../_services/property.service';
import { first } from 'rxjs';
import { environment } from '../../environments/environment';

@Component({
    selector: 'app-choose-property',
    templateUrl: './choose-property.component.html',
    styleUrls: ['./choose-property.component.css'],
    standalone: false
})
export class ChoosePropertyComponent {
  loading = false;

  searchText!: string;

  faSearch = faSearch;
  faArrowRight = faArrowRight;
  faHouse = faHouse;
  faBuilding = faBuilding;


  properties!: Property[];

  constructor(private propertyService: PropertyService) { }

  ngOnInit(): void {
    this.loading = true;
    this.propertyService.getMyPropertyAssociations().pipe(first()).subscribe(
      {
        next: (associations: any[]) => {
          this.properties = associations.map(assoc => ({
            id: assoc.propertyId,
            name: assoc.propertyDetails.name,
            property_type: assoc.propertyDetails.property_type,
            address: assoc.propertyDetails.address,
            obligationCategoryId: assoc.propertyDetails.obligationCategoryId ?? 0,
            premises: []
          })) || [];
          if (!environment.production) {
            console.log('Property data: ', this.properties);
          }

        },
        error: (error) => {
          if (!environment.production) {
            console.log('Fail to load property data: ', error);
          }

        }
      }
    )
  }

  loadRequestPage(property: any) {

  }
}
